export default "__VITE_ASSET__Bm0PzYJM__"